import type { DateTime } from 'src/apis/api-utilities';
import type { SurrenderRequestInquiryStatus } from 'src/apis/surrender-service/types';
import type { FormOption } from 'src/components/form/form-option';
import type { WizardState } from 'src/components/wizard/state';
import type { ConstraintViolation } from 'src/utils/is-constraint-violation';

export const getSurrenderInquiryWizardName = (bundleId: string) =>
  `surrender-inquiry:bundle:${bundleId}`;

export const getCreateSurrenderInquiryStepPaths = (bundleId: string) => {
  const base = `/reporting/my-transactions/surrender/create/bundle/${bundleId}`;
  return {
    specify: base,
    confirm: `${base}/confirm`,
    success: `${base}/success`,
  };
};

type SpecifyStepData = {
  exitContractId: string | null;
  entryContractId: string | null;
  dealId: FormOption | null;
  exitBalancingGroupOrPortfolioCode: FormOption | null;
  entryBalancingGroupOrPortfolioCode: FormOption | null;
  periodStart: string | null;
  periodEnd: string | null;
  capacity: number | null;
  constraintViolation?: ConstraintViolation;
};

export type ConfirmStepData = {
  acceptedExitTerms: boolean;
  acceptedEntryTerms: boolean;
  inquiryProcessId: string | null;
  inquiryProcessBusinessId: string | null;
  pollStartedAt: number | null;
};

type SuccessStepData = {
  status: SurrenderRequestInquiryStatus;
  createdBy: string;
  finishedAt?: DateTime;
  assignedSurrenderId?: string;
  surrenderRequestId: string;
  inquiryProcessId: string;
};

export type CreateSurrenderInquiryWizardStepsData = [
  SpecifyStepData,
  ConfirmStepData,
  SuccessStepData,
];

export type CreateSurrenderInquiryWizard =
  WizardState<CreateSurrenderInquiryWizardStepsData>;
